import React from 'react';
import { Line } from 'react-chartjs-2';
import CHART_OPTIONS from './ChartOptions';

// Function that returns percentage of points to display
// depending on the current amount of points being returned
var interpolate = function interpolate(N) {
  if (!N) return 0;

  if (N < 20) {
    return 1.0;
  } else if (N < 60) {
    return 1 + (N - 20) / (60 - 20) * (0.5 - 1);
  } else if (N < 130) {
    return 0.5 + (N - 60) / (130 - 60) * (0.3 - 0.5);
  } else if (N < 240) {
    return 0.3 + (N - 130) / (130 - 240) * (0.15 - 0.3);
  } else if (N < 1400) {
    return 0.15 + (N - 240) / (240 - 1400) * (0.04 - 0.15);
  } else if (N >= 1400) {
    return 0.04;
  }

  return 0;
};

var hexToRgb = function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

export var CustomLine = function CustomLine(_ref) {
  var prices = _ref.prices,
      tooltipActive = _ref.tooltipActive,
      lineColor = _ref.lineColor,
      timestamps = _ref.timestamps,
      currentTooltipIndex = _ref.currentTooltipIndex;
  CHART_OPTIONS.elements.line.tension = tooltipActive ? 0.1 : 0.4;

  var getChartData = function getChartData() {
    var rgbColor = hexToRgb(lineColor); // selectedIndex calculation series.count/series.count * percentage

    var iterateAmount = Math.round(prices.length / (prices.length * (interpolate(prices.length) || 0)));
    var percentPoints = [];
    var percentDates = [];

    for (var i = 0; i < prices.length; i += iterateAmount) {
      percentPoints.push(prices[i]);
      percentDates.push(timestamps[i]);
    } // TempPoints are the points that are deleted/added when using the drag opacity effect


    var tempPoints = tooltipActive ? prices.slice(0, (currentTooltipIndex || 0) + 1) : percentPoints;
    var opacityPoints = tooltipActive ? prices : percentPoints;
    return {
      labels: tooltipActive ? timestamps : percentDates,
      datasets: [{
        label: 'opacity chart',
        data: opacityPoints,
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHitRadius: 0,
        fill: false,
        borderColor: rgbColor ? "rgba(".concat(rgbColor.r, ", ").concat(rgbColor.g, ", ").concat(rgbColor.b, ", 0.5)") : '',
        borderWidth: tooltipActive ? 2 : 3
      }, {
        label: 'normal chart',
        data: tempPoints,
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHitRadius: 5,
        fill: false,
        borderColor: lineColor,
        borderWidth: tooltipActive ? 2 : 3
      }]
    };
  };

  return /*#__PURE__*/React.createElement(Line, {
    data: getChartData,
    options: CHART_OPTIONS
  });
};